export const handleTitleOption = (
  certificateType,
  ownergainFindOptionType,
  titleOption
) => {
  const ownergainTitleOptionFilter = titleOption?.filter(
    (title) => title?.option === ownergainFindOptionType
  );
  const ownergainTitleOption = ownergainTitleOptionFilter?.map((item) => ({
    value: item?.title,
    label: item?.title,
  }));
  const defaultOp = handleTitleDefaultOption(certificateType);
  const defaultSe = handleTitleDefaultSelect(certificateType);
  ownergainTitleOption?.push(defaultSe);
  ownergainTitleOption?.unshift(defaultOp);

  return ownergainTitleOption;
};

export const handleTitleDefaultSelect = (certificateType) => {
  const data = {
    value: "all",
    label: certificateType === 1 ? "লিখুন" : "Write New",
  };
  return data;
};
export const handleTitleDefaultOption = (certificateType) => {
  const data = {
    value: "",
    label: certificateType === 1 ? "নির্বাচন করুন..." : "Select...",
  };
  return data;
};
